'use client';

import { ReactNode, useEffect, useId } from 'react';
import { SectionStatus, useSettingsPanel } from './SettingsPanelContext';

interface Props {
    id?: string;
    title: string;
    description?: string;
    status?: SectionStatus;
    /**
     * Extra terms for Cmd+K search. Note: global Cmd+K registration is centralized in
     * `components/CommandPalette/settingsSectionsNavItems.ts` so sections are discoverable
     * before their page is visited. Keep that registry in sync when adding/renaming sections.
     */
    keywords?: string;
    children: ReactNode;
}

export function SettingsSection({ id: providedId, title, description, status, keywords, children }: Props) {
    const generatedId = useId();
    const id = providedId ?? generatedId;
    const { activeId, register, unregister } = useSettingsPanel();

    useEffect(() => {
        register({ id, title, description, status, keywords });
        return () => unregister(id);
    }, [id, title, description, status, keywords]);

    if (activeId !== id) return null;

    return <div className="tw-space-y-4">{children}</div>;
}
